// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const RemoveCircle = React.forwardRef(function RemoveCircle(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/></SvgIcon>;
});
export default RemoveCircle;
